export default __webpack_public_path__ + "static/media/fpPlaceholder.f6779628.png";